<template>
  <div class="header">
    <div class="menu-wrapper">
      <div class="logo" @click="goHome">
        <UiBaseIcon width="160px" height="85px" color="#404041" iconName="melodie"/>
      </div>
      <div class="side-menu-icon">
        <ul class="menu">
          <li class="menu-item">
            <router-link :to="{ name: 'index' }" exact>home</router-link>
          </li>
          <li class="menu-item">
            <router-link :to="{ name: 'intro' }">intro</router-link>
          </li>
          <li class="menu-item">
            <router-link :to="{ name: 'gallery' }">gallery</router-link>
          </li>
          <li class="menu-item">
            <a href="https://events.djmelodie.com" target="blank">events</a>
          </li>
          <li class="menu-item">
            <router-link :to="{ name: 'contact' }">contact</router-link>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import UiHeaderDropdownMenu from "@/components/UiHeaderDropdownMenu.vue";
import UiToastList from "@/components/UiToastList";
import UiBaseIcon from "@/components/icons/UiBaseIcon.vue";

export default {
  name: "Header",
  components: {
    UiToastList,
    UiHeaderDropdownMenu,
    UiBaseIcon
  },
  methods: {
    goHome() {
      this.$router.push({ name: "index" });
    }
  }
};
</script>

<style lang="scss" scoped>
.header {
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  margin: 0 auto;
  left: 0;
  padding: $header-padding-v $header-padding-h;
  position: fixed;
  transition-property: background-color, box-shadow;
  transition-duration: 0.5s;
  transition-timing-function: ease;
  top: 0;
  width: 100%;
  z-index: 10;

  .is-active {
    color: $secondary-color;
    font-size: 700;
  }

  a {
    color: $dark-color;
    text-decoration: none;
  }

  .menu-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .logo {
    cursor: pointer3;
    font-size: 25px;
    text-transform: uppercase;
    display: flex;
    justify-content: center;
    align-items: center;

    &.side {
      font-size: 15px;
    }
  }

  .menu {
    display: inline-flex;
    width: 100%;
    justify-content: space-around;

    > .menu-item {
      margin: 0 1rem;
      &:hover {
        cursor: pointer;
      }

      > a {
        display: block;
        font-size: 1rem;
        text-transform: uppercase;
        letter-spacing: 2px;
        text-align: center;
        font-family: $title;
        padding: 8px 0;
        position: relative;

        &:hover {
          color: darken($dark-color, 10%);

          &:before {
            background: darken($dark-color, 10%);
            width: 100%;
            transition: width 0.5s cubic-bezier(0.22, 0.61, 0.36, 1);
          }

          &:after {
            background: transparent;
            width: 100%;
            transition: 0s;
          }
        }

        &:before,
        &:after {
          content: "";
          position: absolute;
          width: 0;
          height: 4px;
          bottom: -4px;
          background: darken($dark-color, 10%);
        }

        &:before {
          left: 0;
        }

        &:after {
          right: 0;
          background: darken($dark-color, 10%);
          transition: width 0.8s cubic-bezier(0.22, 0.61, 0.36, 1);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/Header.vue